import { Heart } from "lucide-react";

/**
 * TransitionReassurance — a small, warm message designed to appear
 * between questions in multi-step triage flows. De-escalates
 * anxiety for vulnerable residents who may fear losing their home.
 *
 * Rotates between gentle messages based on `step` so copy feels human,
 * not repetitive.
 */
const MESSAGES = [
  "Thank you for answering that. You're doing great — let's look at the next step together.",
  "We know these rules can feel overwhelming. Take your time, there's no rush.",
  "Nearly there. Every answer helps us give you clearer guidance.",
  "You're being really thorough — this is exactly how to approach it.",
  "Almost done. Thank you for trusting this process.",
];

export default function TransitionReassurance({ step = 0 }) {
  if (step <= 0) return null;
  const message = MESSAGES[(step - 1) % MESSAGES.length];

  return (
    <div
      className="flex items-start gap-2 text-xs text-gray-600 italic bg-[#FFFBF2] border border-[#F47738] border-opacity-20 rounded px-3 py-2 mb-4"
      data-testid="transition-reassurance"
    >
      <Heart size={14} className="text-[#F47738] mt-0.5 flex-shrink-0" />
      <span>{message}</span>
    </div>
  );
}
